export default __webpack_public_path__ + "static/logo-9e597cd2f63a7319271a1def82e58039.png";